import React, { useEffect, useState } from 'react'
import { BASE_URL } from '../../api/api';

const PaymentMISHook = () => {
    const [pendingData, setPendingData] = useState([]);
    const [paidData, setPaidData] = useState([]);
    const [utrData, setUtrData] = useState([]);
const VENDOR_LIST = [
  "Self Repairs",
  "Chitransh Enterprises - Jaipur",
  "Total Solution - Bihar",
  "Across Assist PAN India",
  "Care Point - Jodhpur",
  "Mayra Communication - Ahmedabad",
  "Home App. Xprt - Noida",
  "Vaeg Info - UP West",
  "Cell Service - Ahmedabad",
  "Laxmi Enterprises - Ranchi",
  "Abhistha Enterprises",
  "SP Enterprises - Lucknow",
  "G Care - Ghaziabad",
  "Peekay Sales - Ludhiana",
  "Rank Claims Seva Pvt Ltd",
  "TGS Services - Orisa",
  "AD Electronics - Alwar",
  "Airtel Payments Bank",
  "NPD Enterprises - Meerut",
  "Cashify",
  "Twoare Tech. - Jaipur",
  "Shriram Mobile - Jaipur",
];
useEffect(() => {
  const fetchMIS = async () => {
    try {
      const res = await fetch(`${BASE_URL}/GetPendingPaymentMIS`);
      const data = await res.json();

      if (data?.status && Array.isArray(data.dataList)) {
        setPendingData(data.dataList);
        setPaidData(data.dataList);
        setUtrData(data.dataList);
      }
    } catch (err) {
      console.error("Error fetching MIS:", err);
    }
  };

  fetchMIS();
}, []);


    return {
        pendingData, paidData, utrData,setPendingData,setPaidData,setUtrData,VENDOR_LIST
    }
}

export default PaymentMISHook
